import { apiClient } from "../lib/apiClient";
import type { DateOnlyString } from "../utils/dateOnly";
import { normalizeDateOnlyQueryRange } from "./dateOnlyQuery";

export type BridgeDeviceType =
  | "sticker_printer"
  | "slide_printer"
  | "cassette_printer"
  | "document_scanner"
  | "stainer";

export type BridgeAuditEventType =
  | "print"
  | "reprint"
  | "scan"
  | "test"
  | "stain_send"
  | "stain_status";

export type BridgeAuditOutcome =
  | "pending"
  | "success"
  | "failed_bridge"
  | "failed_device";

export interface BridgeAuditRow {
  id: string;
  deviceId: string | null;
  deviceType: BridgeDeviceType;
  deviceName: string | null;
  workstationId: string | null;
  workstationName: string | null;
  userId: string | null;
  userName: string | null;
  caseId: string | null;
  caseNumber: string | null;
  itemId: string | null;
  itemType: string | null;
  eventType: BridgeAuditEventType;
  outcome: BridgeAuditOutcome;
  failureReason: string | null;
  clientRequestId: string | null;
  bridgeCommandId: string | null;
  isReprint: boolean;
  copies: number;
  startedAt: string;
  completedAt: string | null;
  metadata: Record<string, any> | null;
}

export interface BridgeAuditQueryParams {
  deviceType?: BridgeDeviceType;
  eventType?: BridgeAuditEventType;
  outcome?: BridgeAuditOutcome;
  workstationId?: string;
  deviceId?: string;
  userId?: string;
  caseId?: string;
  itemId?: string;
  search?: string;
  from?: DateOnlyString;
  to?: DateOnlyString;
  limit?: number;
  offset?: number;
}

export const bridgeAuditService = {
  list: async (params: BridgeAuditQueryParams) => {
    const dateRange = normalizeDateOnlyQueryRange(
      { from: params.from, to: params.to },
      { from: "from", to: "to" }
    );
    const response = await apiClient.get<{
      rows: BridgeAuditRow[];
      total: number;
    }>("/bridge/audits", {
      params: {
        ...params,
        from: dateRange.from,
        to: dateRange.to,
      },
    });
    return response.data;
  },
};
